<template>
  <a-modal
    :title="title"
    :visible="visible"
    @ok="handleOk"
    @cancel="handleCancel"
    :confirmLoading="confirmLoading"
  >
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item :label="$t('class.addStudentModal.student')" prop="studentIds" style="margin-bottom: 0;">
        <div class="search-item">
          <a-select
            v-model="form.studentIds"
            mode="multiple"
            :placeholder="$t('class.addStudentModal.selectStudent')"
            :filterOption="filterStudentOption"
            showSearch
          >
            <a-select-option v-for="student in studentOptions" :key="student.value" :value="student.value">
              {{ student.label }}
            </a-select-option>
          </a-select>
          <img class="searchIcon" src="@/assets/icons/icon_s@2x.png" alt="">
        </div>
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
import { getAvailableStudents, getAvailableStudentsForAdmin, addClassStudent } from '@/api/admin'

export default {
  name: 'AddStudentModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default() {
        return this.$t('class.addStudentModal.title')
      }
    },
    classId: {
      type: [String, Number],
      required: true
    },
    classType: {
      type: [String, Number],
      required: true
    }
  },
  data() {
    return {
      confirmLoading: false,
      form: {
        studentIds: []
      },
      rules: {
        studentIds: [{ required: true, type: 'array', message: this.$t('class.addStudentModal.required'), trigger: 'change' }]
      },
      studentOptions: []
    }
  },
  watch: {
    visible(val) {
      if (val) {
        if (this.classType === '1') {
          this.getAvailableStudentsForAdmin()
        } else {
          this.getAvailableStudents()
        }
      } else {
        this.resetForm()
      }
    }
  },
  methods: {
    resetForm() {
      this.$refs.form && this.$refs.form.resetFields()
      this.form.studentIds = []
    },
    handleCancel() {
      this.$emit('cancel')
      this.resetForm()
    },
    async handleOk() {
      try {
        const valid = await this.$refs.form.validate()
        if (valid) {
          this.confirmLoading = true
          const res = await addClassStudent({
            studentIds: this.form.studentIds,
            classId: this.classId,
            classType: this.classType
          })
          if (res.code === 200) {
            this.$message.success(this.$t('class.addStudentModal.addSuccess'))
            this.$emit('success')
            this.resetForm()
          }
        }
      } catch (error) {
        console.log(error)
        console.error('添加学生失败:', error)
        this.$message.error(this.$t('class.addStudentModal.addFailed'))
      } finally {
        this.confirmLoading = false
      }
    },
    async getAvailableStudents() {
      try {
        const res = await getAvailableStudents({
          page: 1,
          pageSize: 1000,
          notInClass: this.classId
        })
        if (res.code === 200) {
          this.studentOptions = res.data.list.map(student => ({
            label: `${student.name} (${student.studentNumber || this.$t('class.addStudentModal.noStudentNumber')})`,
            value: student.id
          }))
        }
      } catch (error) {
        console.error('获取可用学生列表失败:', error)
        this.$message.error(this.$t('class.addStudentModal.getStudentListFailed'))
      }
    },
    async getAvailableStudentsForAdmin() {
      try {
        const res = await getAvailableStudentsForAdmin({
          page: 1,
          pageSize: 1000,
          notInClass: this.classId
        })
        if (res.code === 200) {
          this.studentOptions = res.data.list.map(student => ({
            label: `${student.name} (${student.studentNumber || this.$t('class.addStudentModal.noStudentNumber')})`,
            value: student.id
          }))
        }
      } catch (error) {
        console.error('获取可用学生列表失败:', error)
        this.$message.error(this.$t('class.addStudentModal.getStudentListFailed'))
      }
    },
    filterStudentOption(input, option) {
      if (!input || !option || !option.componentOptions || !option.componentOptions.children) {
        return true
      }
      const text = option.componentOptions.children[0].text || ''
      return text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .ant-select {
  width: 100%;
}
/deep/ .search-item{
  position: relative;
  width: 100%;
  .searchIcon{
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    color: #999;
    width: 16px;
    height: 16px;
    line-height: 20px;
    text-align: center;
    opacity: 0.7;
  }
}
</style>
